export type CompanyTypeCategory = "label" | "distributor" | "other";

// Includes current label/company creation form options plus legacy values
// still present on older production records (predate a naming convention
// change): "Independent" and "Major" (legacy short form of "Major Label").
const LABEL_TYPES = new Set([
  "Indie Label",
  "Major Label",
  "Major Affiliated Indie",
  "Independent",
  "Major",
]);

export function classifyCompanyType(rawType?: string | null): CompanyTypeCategory {
  if (!rawType) return "other";
  if (rawType === "Distributor") return "distributor";
  if (LABEL_TYPES.has(rawType)) return "label";
  return "other";
}
